import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import axios from "axios";
import { CircularProgress } from "@mui/material";
import Box from "@mui/material/Box";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function CustomDialog({
  open,
  handleClose,
  image,
  videoUrl,
  title,
  showSaveToDesktop = true,
}) {
  const [loading, setLoading] = React.useState(false);
  const [isZoomed, setIsZoomed] = React.useState(false);
  const [zoomPosition, setZoomPosition] = React.useState({ x: 50, y: 50 });

  const handleZoomMove = (event) => {
    const { currentTarget, clientX, clientY } = event;
    const rect = currentTarget.getBoundingClientRect();
    const x = ((clientX - rect.left) / rect.width) * 100;
    const y = ((clientY - rect.top) / rect.height) * 100;
    setZoomPosition({
      x: Math.max(0, Math.min(100, x)),
      y: Math.max(0, Math.min(100, y)),
    });
  };

  const resetZoom = () => {
    setIsZoomed(false);
    setZoomPosition({ x: 50, y: 50 });
  };

  const handleSaveToDesktop = () => {
    setLoading(true);

    const proxyBase =
      process.env.REACT_APP_DOWNLOAD_PROXY_URL ||
      "https://proxy-iota-ten.vercel.app/proxy";
    const proxyUrl = `${proxyBase}?url=${encodeURIComponent(image)}`;

    axios
      .get(proxyUrl, { responseType: "blob" })
      .then((response) => {
        const blobUrl = URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", "downloaded_image.jpg");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
      })
      .catch((error) => console.error("Error downloading image:", error))
      .finally(() => setLoading(false));
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      maxWidth="lg"
      maxHeight="60vh"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          maxWidth: { xs: "95vw", md: "85vh" },
          maxHeight: { xs: "92vh", md: "85vh" },
          overflow: "hidden",
          position: "relative",
          borderRadius: "24px",
        },
      }}>
      <Box
        onClick={handleClose}
        sx={{
          position: "absolute",
          top: "30px",
          right: "30px",
          zIndex: 1000,
          cursor: "pointer",
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          borderRadius: "50%",
          padding: "6px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          transition: "transform 0.2s ease",
        }}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M10.998 13V19H8.99805V15H4.99805V13H10.998ZM14.998 5V9H18.998V11H12.998V5H14.998Z"
            fill="black"
          />
        </svg>
      </Box>
      <DialogContent sx={{ padding: "0px !important", overflow: "hidden" }}>
        <Box sx={{ padding: 0, position: "relative" }}>
          {videoUrl ? (
            <video
              src={videoUrl}
              autoPlay
              controls
              style={{ objectFit: "contain", height: "70vh", width: "100%" }}
            />
          ) : (
            <Box
              onMouseEnter={() => setIsZoomed(true)}
              onMouseMove={handleZoomMove}
              onMouseLeave={resetZoom}
              sx={{
                width: "100%",
                height: "70vh",
                cursor: isZoomed ? "zoom-out" : "zoom-in",
                backgroundImage: `url("${image}")`,
                backgroundRepeat: "no-repeat",
                backgroundSize: isZoomed ? "220%" : "contain",
                backgroundPosition: `${zoomPosition.x}% ${zoomPosition.y}%`,
                backgroundColor: "#fff",
                transition: "background-size 0.2s ease",
              }}
              role="img"
              aria-label={title}
            />
          )}
        </Box>
      </DialogContent>
      {!videoUrl && showSaveToDesktop && (
        <DialogActions sx={{ justifyContent: "flex-start" }}>
          <Button
            variant="contained"
            onClick={handleSaveToDesktop}
            sx={{
              backgroundColor: "#333",
              "&:hover": { backgroundColor: "#333" },
              flex: 1,
              marginBottom: "8px",
              ml: "8px",
            }}>
            {loading ? (
              <CircularProgress sx={{ color: "#fff" }} size={24} />
            ) : (
              "Save to Desktop"
            )}{" "}
          </Button>
        </DialogActions>
      )}
    </BootstrapDialog>
  );
}
